const VENDOR_CONTEXT_EXACT_PATHS = new Set<string>();
const VENDOR_CONTEXT_DISABLED_PREFIXES = ['/auth'];
const VENDOR_CONTEXT_DEFERRED_BOOTSTRAP_DELAYS = new Map<string, number>([
  ['/marketplace', 1000],
]);

export function shouldHydrateVendorContext(pathname: string) {
  if (VENDOR_CONTEXT_EXACT_PATHS.has(pathname)) {
    return true;
  }

  return !VENDOR_CONTEXT_DISABLED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function getVendorContextBootstrapDelayMs(pathname: string) {
  return VENDOR_CONTEXT_DEFERRED_BOOTSTRAP_DELAYS.get(pathname) ?? 0;
}
